import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleMergeHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateMergeSearch } from './-people-merge-search';

/**
 * The legacy `/journeys/profiles/merge` URL — the canonical segment for accounts
 * on the taxonomy rename (the Ember router flag-swaps `people`/`profiles`).
 * Flag off it renders the embedded Ember host; flag on it forwards to the
 * migrated URL, same as the `/journeys/people/merge` twin.
 */
function JourneysProfilesMergeRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleMergeHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/profiles/merge')({
  component: JourneysProfilesMergeRoute,
  validateSearch: validateMergeSearch,
});
